import { useEffect } from 'react';

import { type EchoSubmitFn, useAutoNavigate } from '@betterment/js-runtime';

export function useEchoEvents(onSubmit: EchoSubmitFn): void {
  const autoNavigate = useAutoNavigate();

  useEffect(() => {
    const onNavigate = (event: CustomEvent<{ url: string }>) => {
      event.preventDefault();
      void autoNavigate(event.detail.url);
    };

    document.addEventListener('island:navigate', onNavigate);
    document.addEventListener('typed:redirect', onNavigate);

    return () => {
      document.removeEventListener('island:navigate', onNavigate);
      document.removeEventListener('typed:redirect', onNavigate);
    };
  }, [autoNavigate]);

  useEffect(() => {
    const onIslandSubmit = (event: HTMLElementEventMap['island:submit']) => {
      event.preventDefault();
      return onSubmit(event.target as HTMLFormElement, null).then(event.detail.resolve, event.detail.reject);
    };

    document.addEventListener('island:submit', onIslandSubmit);
    return () => document.removeEventListener('island:submit', onIslandSubmit);
  }, [onSubmit]);
}
